/* eslint-disable import/prefer-default-export */
import { Button } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledApproveButton = styled(Button)`
    width: 200px;
`;
